import { FC } from 'react';
import { AdvertServiceDataType } from '@edikk-edikk/country-frontend';
import modelDetailParameterCss from '../../assets/model-detail/model-detail-parameter.module.scss';
import { ServiceLabel, ServiceValue, ServiceComment } from '#advertDetail/components/service-list';

type PropsType = {
  serviceData: AdvertServiceDataType;
};

const Service: FC<PropsType> = ({
  serviceData,
}) => (
  <div className={modelDetailParameterCss.modelDetailParameter}>
    <ServiceLabel serviceData={serviceData} />
    <ServiceValue serviceData={serviceData} />
    <ServiceComment serviceData={serviceData} />
  </div>
);

export { Service };
